<template>
    <div>
        <Field
            :name="fieldName('street')"
            v-model="value.street"
            label="Numéro et voie"
            required
            :errors="errors"
        />

        <div class="row">
            <div class="col-sm-8 col-md-9">
                <Field :name="fieldName('complement')" v-model="value.complement" label="Complément" :errors="errors" />
            </div>
            <div class="col-sm-4 col-md-3">
                <PostalBoxField
                    v-model="value.postal_box"
                    :name="fieldName('postal_box')"
                    :errors="errors"
                />
            </div>
        </div>

        <Field class="mt-2" :name="fieldName('is_foreign')">
            <div class="form-check">
                <input
                    id="is_foreign"
                    :name="fieldName('is_foreign', true)"
                    class="form-check-input"
                    v-model="value.is_foreign"
                    value="1"
                    type="checkbox"
                    @change="handleIsForeignChanged"
                >
                <label for="is_foreign" style="font-size: .875rem">
                    Adresse non française
                </label>
            </div>
        </Field>

        <template v-if="value.is_foreign">
            <div class="row">
                <div class="col-sm-5 col-lg-4">
                    <Field
                        :name="fieldName('postal_code')"
                        v-model="value.postal_code"
                        label="Code postal"
                        required
                        :errors="errors"
                    />
                </div>
                <div class="col">
                    <Field
                        :name="fieldName('city')"
                        v-model="value.city"
                        label="Ville"
                        required
                        :errors="errors"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-7">
                    <Field
                        :name="fieldName('country')"
                        v-model="value.country"
                        label="Pays"
                        required
                        :errors="errors"
                    />
                </div>
            </div>
        </template>
        <template v-else>
            <postal-code-city
                :value="{
                    postalCode: value.postal_code,
                    city: value.city,
                    cedex: value.cedex,
                    cedexNumber: value.cedex_number
                }"
                postal-code-label="Code postal *"
                postal-code-col="col-sm-6 col-md-5"
                :postal-code-error="error('postal_code')"
                :postal-code-name="fieldName('postal_code', true)"
                city-col="col"
                city-label="Ville *"
                :city-error="error('city')"
                :city-name="fieldName('city', true)"
                :cedex-error="error('cedex')"
                :cedex-name="fieldName('cedex_name', true)"
                :cedex-number-error="error('cedex_number')"
                :cedex-number-name="fieldName('cedex_number', true)"
                default-label-style
                @input="handlePostalCodeChanged"
            >
                <template v-slot:postal-code-label>
                    Code postal * <span class="text-muted ml-1" style="font-weight: normal">(sans cedex)</span>
                </template>
            </postal-code-city>
        </template>

        <template v-if="showPhone">
            <PhoneForm :value="value" :name="name" :errors="errors" @input="handlePhoneChanged" />
        </template>

        <template v-if="showComment">
            <Field :name="fieldName('comment')" label="Précision adresse / commentaire(s)" :errors="errors" v-slot="{ id, name }">
                <textarea
                    class="form-control"
                    v-model="value.comment"
                    :name="name"
                    :id="id"
                    rows="3"
                ></textarea>
            </Field>
        </template>
    </div>
</template>

<script>
    import Field from "../Field.vue";
    import PostalBoxField from './PostalBoxField.vue';
    import { fieldError, fieldNameAttribute } from "../../util/form";
    import PhoneForm from "./PhoneForm.vue";

    export default {
        components: {
            PostalBoxField,
            PhoneForm,
            Field,
        },
        props: {
            value: Object,
            errors: Object,
            showComment: {
                type: Boolean,
                default: true,
            },
            showPhone: {
                type: Boolean,
                default: true,
            },
            name: {
                type: String,
                default: 'address',
            },
        },
        methods: {
            fieldName(name, isAttribute) {
                const fieldName = `${this.name}.${name}`;
                return isAttribute ? fieldNameAttribute(fieldName) : fieldName;
            },
            error(name) {
                return fieldError(this.errors, this.fieldName(name));
            },
            handlePhoneChanged(value) {
                this.$emit('input', {
                    ...this.value,
                    ...value,
                });
            },
            handlePostalCodeChanged(address) {
                const { postalCode, city, cedexNumber, cedex } = address;
                this.$emit('input', {
                    ...this.value,
                    postal_code: postalCode,
                    cedex_number: cedexNumber,
                    city,
                    cedex,
                });
            },
            handleIsForeignChanged() {
                this.$emit('input', {
                    ...this.value,
                    postal_code: null,
                    city: null,
                    country: null,
                    cedex: null,
                    cedex_number: null,
                });
            },
        },
    }
</script>
